import { post } from 'app/shared/utils/fetchr';

// Actions
import { teamsSearch as teamsSearchAction } from 'app/modules/search/actions';

// Utils
import routes from 'app/shared/utils/routes';

export const teamsSearch = (
  payload: ReturnType<typeof teamsSearchAction>['payload'],
) => {
  return post(routes.patronus.teamsSearch, payload);
};
